import { Fluxs, type Flux } from './fluxs'
import { type Fetch } from './types'
import { buildFetch } from './buildFetch'

export function useFetch(fluxName: Flux): Fetch {
  const flux = Fluxs[fluxName]
  return buildFetch(flux)
}
